import styled from 'styled-components'
import { FlexColumn } from 'components/common/common_styles'
import { sizeMobile } from 'components/globalStyles'

export const TitleColumnContainer = styled(FlexColumn)`
  width: fit-content;
  min-width: 30ch;

  @media (max-width: ${sizeMobile}) {
    width: 100%;
    max-width: none;
    min-width: 0;
  }
`
